import { render } from "./emailVerification.vue?vue&type=template&id=3f63c23a&scoped=true"
import script from "./emailVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./emailVerification.vue?vue&type=script&setup=true&lang=js"

import "./emailVerification.vue?vue&type=style&index=0&id=3f63c23a&scoped=true&lang=css"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f63c23a"],['__file',"src/views/me/emailVerification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f63c23a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f63c23a', __exports__)) {
    console.log('reload')
    api.reload('3f63c23a', __exports__)
  }
  
  module.hot.accept("./emailVerification.vue?vue&type=template&id=3f63c23a&scoped=true", () => {
    console.log('re-render')
    api.rerender('3f63c23a', render)
  })

}


export default __exports__